import { IconFromSet } from "@gettactic/components/src/icons";
import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";
import { parseZoneIcon } from "./zoneTree";

export interface ZoneSwatchProps {
  color: string;
  icon?: string | null;
  size?: "sm" | "md";
  className?: string;
}

/** The zone's colour as a tile, with its icon when it has one. */
export const ZoneSwatch: React.FC<ZoneSwatchProps> = ({
  color,
  icon,
  size = "sm",
  className
}) => {
  const iconValue = parseZoneIcon(icon);
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-md border border-black/10 text-white",
        size === "sm" ? "h-5 w-5" : "h-8 w-8",
        className
      )}
      style={{ backgroundColor: color }}
      aria-hidden
    >
      {iconValue ? (
        <IconFromSet
          icon={iconValue}
          size={size === "sm" ? 3 : 5}
          color="#fff"
        />
      ) : null}
    </span>
  );
};
